import {
  CopyOutlined,
  FileUnknownOutlined,
  LoadingOutlined,
  ProfileOutlined,
  SaveOutlined,
} from '@ant-design/icons'
import { Button, Divider, Modal, Space, Table, Tooltip, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import React, { useState } from 'react'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router-dom'
import { ShareLinkButton } from '~/components/DefaultLayout/Buttons/buttonStyle'
import { useMaintenance } from '~/hooks/Maintenance/useMaintenance'
import { translate } from '~/utils/locale'

// import { Container } from './styles';

interface MaintenanceProps {
  _id: string
  company_id: string
  name?: string
  customer?: {
    id: string
    name: string
    address?: {
      zip_code: string
      street: string
      number: string
      complement: string
      neighborhood: string
      city: string
      state: string
      location: { x: number; y: number }
    }
  }
  description?: string
  future_days?: number
  responsible: {
    name: string
    phone: string
    id: string
  }
  documents: [
    {
      _id: string
      name: string
      provided_responsible: string
      renovation_responsible: string
      inclusion_date: Date
      renovation_date: Date
      attchment: string
      tag: string
    },
  ]
}

const MaintenancePlanClone: React.FC = () => {
  const { maintenance, createMaintenance, isLoading } = useMaintenance()
  const [plan, setPlan] = useState<MaintenanceProps[]>([])
  const [isSaveButton, setIsSaveButton] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

  const { Text } = Typography

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    try {
      const formatData = {
        name: plan[0].name,
        customer: {
          name: plan[0].customer?.name,
          id: plan[0]?.customer?.id,
          address: plan[0]?.customer?.address,
        },
        description: plan[0].description,
        responsible: {
          name: plan[0].responsible.name,
          phone: plan[0].responsible.phone,
          id: plan[0].responsible.id,
        },
        future_days: plan[0].future_days,
      }

      createMaintenance(formatData)

      setIsModalVisible(false)
    } catch (er) {}
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const columns: ColumnsType<MaintenanceProps> = [
    {
      title: 'ID Plano',
      key: '_id',
      render: (record) => (
        <Tooltip title="Ver Equipe">
          <Typography.Link
            copyable={{ text: record._id }}
            href={`/manutencao/visualizar/${record._id}`}
          >
            {record._id.substring(0, 8)}
          </Typography.Link>
        </Tooltip>
      ),
    },
    {
      title: 'Nome do Plano',
      key: 'name',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record) => (
        <Link to={`/manutencao/visualizar/${record._id}`}>{record.name}</Link>
      ),
    },
    {
      title: translate('MaintenanceTable.clientColumn'),
      key: 'client',
      dataIndex: ['customer', 'name'],
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (customer: string) => (
        <>
          {customer || (
            <Text type="secondary">
              <Space size="small">
                <FileUnknownOutlined />
                N/A
              </Space>
            </Text>
          )}
        </>
      ),
    },
    {
      title: translate('MaintenanceTable.responsibleColumn'),
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record: MaintenanceProps) => (
        <>
          {record?.responsible?.name ? (
            <Text>{record?.responsible?.name}</Text>
          ) : (
            <Text type="secondary">
              <Space size="small">
                <FileUnknownOutlined />
                N/A
              </Space>
            </Text>
          )}
        </>
      ),
    },
    {
      title: translate('MaintenanceTable.responsiblePhoneColumn'),
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record: MaintenanceProps) => (
        <>
          {record?.responsible?.phone ? (
            <Text>
              <NumberFormat
                value={record?.responsible?.phone}
                displayType="text"
                format="+## (##) #####-####"
              />
            </Text>
          ) : (
            <Text type="secondary">
              <Space size="small">
                <FileUnknownOutlined />
                N/A
              </Space>
            </Text>
          )}
        </>
      ),
    },
    {
      title: translate('MaintenanceTable.actionsColumn'),
      align: 'center',
      key: 'remove',
      render: (record) => (
        <Space size="middle">
          <Tooltip title={translate('MaintenanceTable.visualizationButon')}>
            <Link to={`/manutencao/visualizar/${record._id}`}>
              <Button
                ghost
                type="primary"
                shape="circle"
                icon={<ProfileOutlined />}
                size="small"
              />
            </Link>
          </Tooltip>
        </Space>
      ),
    },
  ]

  const rowSelection = {
    selectedRowKeys: plan.map((item) => item._id),
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: MaintenanceProps[],
    ) => {
      setPlan(selectedRows)
      setIsSaveButton(true)
    },
    getCheckboxProps: (record: MaintenanceProps) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  }

  return (
    <>
      <Tooltip title="Clonar Plano">
        <ShareLinkButton icon={<CopyOutlined />} onClick={showModal} />
      </Tooltip>

      <Modal
        title={
          <>
            Clonar Plano de Manutenção
            <Divider style={{ margin: '10px 0' }} />
          </>
        }
        width="850px"
        style={{
          top: 50,
        }}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Space size="middle" key="footer">
            {isSaveButton && (
              <Button type="primary" icon={<SaveOutlined />} onClick={handleOk}>
                Salvar
              </Button>
            )}
          </Space>,
        ]}
      >
        <Table
          rowKey={(record) => record._id}
          loading={{
            indicator: <LoadingOutlined />,
            spinning: isLoading,
            size: 'large',
          }}
          rowSelection={{
            type: 'radio',
            ...rowSelection,
          }}
          size="small"
          scroll={{ x: 1000 }}
          columns={columns}
          dataSource={maintenance}
          pagination={{
            showTotal: (total, range) => `${range[0]} - ${range[1]} / ${total}`,
          }}
        />
      </Modal>
    </>
  )
}

export default MaintenancePlanClone
